import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAdmin } from "../App";
import { toast } from "sonner";
import { BookOpen, Lock, ArrowRight } from "lucide-react";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";

export default function AdminLogin() {
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const { login, isAdmin } = useAdmin();
  const navigate = useNavigate();

  // Redirect if already logged in
  if (isAdmin) {
    navigate("/admin");
    return null;
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!password) {
      toast.error("Please enter the admin password");
      return;
    }

    setLoading(true);
    try {
      await login(password);
      toast.success("Welcome back, Lopa!");
      navigate("/admin");
    } catch (error) {
      toast.error("Invalid password");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6" style={{ background: 'linear-gradient(135deg, #F5F0E7, #E8DCC8, #F5F0E7)' }}>
      {/* Decorative Elements */}
      <div className="absolute top-20 left-20 w-72 h-72 rounded-full blur-3xl" style={{ background: 'rgba(194, 176, 150, 0.3)' }} />
      <div className="absolute bottom-20 right-20 w-96 h-96 rounded-full blur-3xl" style={{ background: 'rgba(138, 134, 119, 0.2)' }} />

      <div className="relative z-10 w-full max-w-md">
        <div className="glass rounded-2xl p-8 shadow-xl">
          <div className="text-center mb-8">
            <div className="w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4" style={{ background: 'var(--skeleton)' }}>
              <BookOpen className="w-8 h-8" style={{ color: '#795A3B' }} />
            </div>
            <h1 className="text-2xl font-bold mb-2" style={{ fontFamily: 'Playfair Display, serif', color: '#4E3E2B' }}>
              Admin Access
            </h1>
            <p style={{ color: '#7A6650' }}>
              Welcome back to The Reading Room
            </p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-6">
            <div className="relative">
              <Lock className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5" style={{ color: '#A08B6F' }} />
              <Input
                data-testid="admin-password"
                type="password"
                placeholder="Enter admin password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="pl-12 py-6"
                style={{ borderColor: 'var(--highlight)', background: '#FDFBF7' }}
              />
            </div>

            <Button 
              type="submit"
              disabled={loading}
              className="w-full py-6 rounded-full font-medium"
              style={{ background: '#795A3B', color: '#F5F0E7' }}
              data-testid="admin-login-btn"
            >
              {loading ? (
                "Signing in..."
              ) : (
                <>
                  Sign In
                  <ArrowRight className="w-5 h-5 ml-2" />
                </>
              )}
            </Button>
          </form>

          <p className="text-center text-sm mt-6" style={{ color: '#A08B6F' }}>
            Only Lopa can access this area
          </p>
        </div>
      </div>
    </div>
  );
}
